import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDecagon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	"aria-hidden": "true",
	role: "img",
	viewBox: "0 0 20 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 4.36087V11.2481L5.96668 14.6917V11.8568L2.45832 9.83063V5.77834L0 4.36087ZM0.524854 3.44362L2.98317 4.86109L8.94986 1.41746L6.49154 0L0.524854 3.44362ZM7.01636 11.8569V14.6918L16.4914 9.22208V6.38715L7.01636 11.8569ZM11.0498 13.5825L13.5081 15L19.4749 11.5564L17.0165 10.1306L11.0498 13.5825ZM20 10.6395V3.75225L14.0335 0.3003V3.14359L17.5418 5.16971V9.222L20 10.6395ZM12.9828 3.14355V0.3003L3.50784 5.77838V8.61334L12.9828 3.14355ZM4.03337 9.53063L6.49173 10.9481L15.9668 5.46998L13.5084 4.05251L4.03337 9.53063Z",
		fill: "currentColor"
	})
});
export default SvgDecagon;
